import { render } from "./accounts.vue?vue&type=template&id=e6543aa2&scoped=true"
import script from "./accounts.vue?vue&type=script&lang=js"
export * from "./accounts.vue?vue&type=script&lang=js"

import "./accounts.vue?vue&type=style&index=0&id=e6543aa2&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6543aa2"]])

export default __exports__